module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Layout_Home":{"widgets.passRetrievSuccess.widget":[{"value":"Popup_Common","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101004},"path":"~.Layout_Home","_fox_":1}],"widgets.passRetrievSuccess.dialog.width":[{"value":"345px","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101005},"path":"~.Layout_Home","_fox_":1}],"widgets.passRetrievSuccess.widgets.content.template":[{"value":"popup_user_passwordRecoverySuccess","lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101006},"path":"~.Layout_Home","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/passRetrive.js
// module id = 676
// module chunks = 4